/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "朋友汇",
      "使用Bumble For Friends APP结交新朋友 | Bumble",
      "前往App Store下载",
      "前往Google Play下载",
      "在这里，只为认识新朋友",
      "发现附近​真心​想要​交朋友​的人。",
      "寻找陪你​度过​不同​人生​阶段​的​朋友",
      "刚搬到这个​新​地方？​想要​有个​崭新​的​开始？​那​就​来​这里​认识​新​朋友​吧！",
      "安全的平台",
      "欢迎来到​互联网​上​这​方​友善​的​天地。​在​这里，​你​可以​放心​做​自己。",
      "下载应用",
      "和与你​有着​共同​爱好​的​人​线下​交流！",
      "在Bumble For Friends使用​Plans​认识​新​的​朋友",
      "您受邀参与Plans",
      "Plans是Bumble For Friends​新​推出​的​板块。​您​可以​使用​Plans​创建​或​加入​线下​活动​群组，​认识​附近​的​新​朋友",
      "管理Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "天"
            ],
            "singular": [
                  "天"
            ]
      },
      "hour": {
            "plural": [
                  "小时"
            ],
            "singular": [
                  "小时"
            ]
      },
      "minute": {
            "plural": [
                  "分钟"
            ],
            "singular": [
                  "分钟"
            ]
      },
      "month": {
            "plural": [
                  "月"
            ],
            "singular": [
                  "月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
